import React from 'react';
import {useMobileNavController, useRootStore} from "@stores/AppStateContext";

import {BackIcon} from "../../../components/icons/BackIcon";
import {getPageTitle} from "../../HeaderMenu";

import {pageAdditionalParamsRef} from "../../../../volatile/pageAdditionalParams";
import {screenSizeProvider} from "../../../../stores/ScreenSizeProvider";

export const GeneralPageHeader = () => {
    const isMobile = screenSizeProvider.view !== 'desktop';
    const rootStore = useRootStore();
    const mobileNav = useMobileNavController();
    const title = getPageTitle(rootStore.view.page);
    let currentBackCb = pageAdditionalParamsRef.current?.back;

    if (!currentBackCb && isMobile) {
        currentBackCb = () => {
            mobileNav.openMainSidebar();
        }
    }

    return (
        <div className={'MobileHeader MobileHeader--simple'}>
            <BackIcon
                className={'MobileHeader__icon'}
                size={24}
                additionalPadding={isMobile ? 12 : undefined}
                onClick={currentBackCb}
            />
            <div>
                <span className='title-medium' style={{ paddingRight: 16 }}>
                    {title}
                </span>
            </div>
        </div>
    )
}
